import { render, staticRenderFns } from "./DarkReconScreenshots.vue?vue&type=template&id=23119650&scoped=true"
import script from "./DarkReconScreenshots.vue?vue&type=script&lang=js"
export * from "./DarkReconScreenshots.vue?vue&type=script&lang=js"
import style0 from "./DarkReconScreenshots.vue?vue&type=style&index=0&id=23119650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23119650",
  null
  
)

export default component.exports